<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" title="搜索校友并绑定" center width="800px" :before-close="$onClose" destroy-on-close @close="close()">
      <div class="body">
        <div>
          <span>学号</span>
          <el-input class="input" v-model="stuNumber" placeholder="请输入学号" suffix-icon="el-icon-search" @input="toSearch"></el-input>
        </div>
        <!-- <div style="clear: both"></div> -->
        <div class="body1">
          <el-image style="width: 158px; height: 203px; float: left" :src="urlPath + info.img_link" fit="cover"></el-image>
          <div class="body2">
            <p>中文姓名：{{ info.name_cn }}</p>
            <p>英文姓名：{{ info.name_en }}</p>
            <p>入学年份：{{ info.year }}</p>
            <p>学部：{{ info.division }}</p>
            <p>专业：{{ info.programme }}</p>
          </div>
        </div>

        <div class="foot">
          <el-button style="width: 106px; float: right" size="small" type="primary" v-preventReClick @click="toSave()">通过审核</el-button>
          <el-button style="width: 106px; float: right; margin-right: 15px" size="small" @click="close()">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
import { isEmpty } from '@/utils/strUtils'
import preventReClick from '@/utils//preventReClick' //防多次点击，重复提交
import * as Constant from '@/utils/constant.js'

export default {
  data() {
    return {
      changVisible: false,
      urlPath: URL_PATH,
      stuNumber: '',
      id: '',
      info: {}
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
      this.stuNumber = ''
      this.info = {}
    },
    toSave() {
      let clickNow = new Date().valueOf()
      if (clickNow - this.clickLastTime < 2000) return
      this.clickLastTime = clickNow
      if (!this.info.id) {
        this.$message.error('先搜索校友')
        return
      }
      this.toPass()
    },
    //页面初始化时加载的事件
    show(id) {
      this.id = id
      this.changVisible = true
    },
    // 搜索校友
    toSearch(value) {
      console.log(this.stuNumber)
      var params = {
        token: localStorage.getItem('token'),
        student_no: this.stuNumber
      }
      this.$api
        .searchStudentNo(params)
        .then(({ data }) => {
          if (data.Data) {
            this.info = data.Data
          } else {
            this.info = {}
          }
        })
        .catch(({ error }) => {})
    },
    // 通过审核
    toPass() {
      var params = {
        token: localStorage.getItem('token'),
        id: this.id,
        ais_info_id: this.info.id,
        is_poss: 'Y'
      }
      this.$api
        .examineAuthenticationLog(params)
        .then(({ data }) => {
          this.$router.go(0)
        })
        .catch(({ error }) => {})
    }
  }
}
</script>

<style lang="less" scoped>
.body {
  background: #ffffff;
  padding: 25px 50px;
}
.body1 {
  margin-top: 24px;
  overflow: hidden;
  // float: left;
}
.body2 {
  float: left;
  width: 490px;
}
.body2 p {
  margin-left: 22px;
  margin-bottom: 20px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
}
.body span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
}
.input {
  width: 208px;
  height: 40px;
  margin-left: 20px;
}
.foot {
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/authenticationSearchAisInfoDialog.vue